import ib1 from '../videos/Portrettfilm/Ibrahim - spørsmål/1-Ibrahim-Hvordan definerer du din identitet.mp4'
import ib2 from '../videos/Portrettfilm/Ibrahim - spørsmål/2-Ibrahim-Hvilken betydning hadde identiteten din for flukten.mp4';
import ib3 from '../videos/Portrettfilm/Ibrahim - spørsmål/3-Ibrahim-Har identiteten din endret seg etter at du kom til Norge.mp4';
import ib4 from '../videos/Portrettfilm/Ibrahim - spørsmål/4-Ibrahim-Hvor føler du deg mest hjemme.mp4';
import ib5 from '../videos/Portrettfilm/Ibrahim - spørsmål/5-Ibrahim-Hvor og når føler du deg mest fremmed.mp4';
import ib6 from '../videos/Portrettfilm/Ibrahim - spørsmål/6-Ibrahim-Kan du uttrykke ulike sider ved din identitet i Norge.mp4';
import ib7 from '../videos/Portrettfilm/Ibrahim - spørsmål/7-Ibrahim-Kan du uttrykke ulike sider ved din identitet om du reiser tilbake til ditt opprinnelsesland.mp4';
import ib8 from '../videos/Portrettfilm/Ibrahim - spørsmål/8-Ibrahim-Hvorfor tror du noen minoriteter blir undertrykt_1.mp4';
import ib9 from '../videos/Portrettfilm/Ibrahim - spørsmål/9-Ibrahim-Are you comfortable in your own skin.mp4';

import in1 from '../videos/Portrettfilm/Inam - spørsmål/1-Inam-Hvordan definerer du din identitet.mp4';
import in2 from '../videos/Portrettfilm/Inam - spørsmål/2-Inam-Hvilken betydning hadde identiteten din for flukt.mp4';
import in3 from '../videos/Portrettfilm/Inam - spørsmål/3-Inam-Har identiteten din endret seg etter at du kom til Norge.mp4';
import in4 from '../videos/Portrettfilm/Inam - spørsmål/4-Inam-Hvor føler du deg mest hjemme.mp4';
import in5 from '../videos/Portrettfilm/Inam - spørsmål/5-Inam-Hvor og når føler du deg mest fremmed.mp4';
import in6 from '../videos/Portrettfilm/Inam - spørsmål/6-Inam-Kan du utrykke ulike sider ved din identitet i Norge.mp4';
import in7 from '../videos/Portrettfilm/Inam - spørsmål/7-Inam-Kan du uttrykke ulike sider ved din identitet om du reiser tilbake til ditt opprinnelsesland.mp4';
import in8 from '../videos/Portrettfilm/Inam - spørsmål/8-Inam-Hvorfor tror du noen minoriteter blir undertrykt.mp4';
import in9 from '../videos/Portrettfilm/Inam - spørsmål/9-Inam-Are you comfortable in your own skin.mp4';


import se1 from '../videos/Portrettfilm/Sevan - spørsmål/1-Sevan-Hvordan definerer du din identitet.mp4';
import se2 from '../videos/Portrettfilm/Sevan - spørsmål/2-Sevan-Hvilken betydning hadde identiteten din for flukten.mp4';
import se3 from '../videos/Portrettfilm/Sevan - spørsmål/3-Sevan-Har identiteten din endret seg etter at du kom til Norge.mp4';
import se4 from '../videos/Portrettfilm/Sevan - spørsmål/4-Sevan-Hvor føler du deg mest hjemme.mp4';
import se5 from '../videos/Portrettfilm/Sevan - spørsmål/5-Sevan-Hvor og når føler du deg mest fremmed.mp4';
import se6 from '../videos/Portrettfilm/Sevan - spørsmål/6-Sevan-Kan du uttrykke ulike sider ved din identitet i Norge.mp4';
import se7 from '../videos/Portrettfilm/Sevan - spørsmål/7-Sevan-Kan du uttrykke ulike sider ved din identitet om du reiser tilbake til ditt opprinnelsesland.mp4';
import se8 from '../videos/Portrettfilm/Sevan - spørsmål/8-Sevan-Hvorfor tror du noen minoriteter blir undertrykt.mp4';
import se9 from '../videos/Portrettfilm/Sevan - spørsmål/9-Sevan-Are you comfortable in your own skin.mp4';

export const videos = [
    {
      person: 'Ibrahim',
      question: 0,
      video: ib1,
      subtitle: "",
      key: "ib0"
    },
    {
        person: 'Ibrahim',
        question: 1,
        video: ib2,
        subtitle: "",
        key: "ib1"
    },
    {
        person: 'Ibrahim',
        question: 2,
        video: ib3,
        subtitle: "",
        key: "ib2"
    },
    {
        person: 'Ibrahim',
        question: 3,
        video: ib4,
        subtitle: "",
        key: "ib3"
    },
    {
        person: 'Ibrahim',
        question: 4,
        video: ib5,
        subtitle: "",
        key: "ib4"
    },
    {
        person: 'Ibrahim',
        question: 5,
        video: ib6,
        subtitle: "",
        key: "ib5"
    },
    {
        person: 'Ibrahim',
        question: 6,
        video: ib7,
        subtitle: "",
        key: "ib6"
    },
    {
        person: 'Ibrahim',
        question: 7,
        video: ib8,
        subtitle: "",
        key: "ib7"
    },
    {
        person: 'Ibrahim',
        question: 8,
        video: ib9,
        subtitle: "",
        key: "ib8"
      },

      {
        person: 'Inam',
        question: 0,
        video: in1,
        subtitle: "",
        key: "in0"
      },
      {
          person: 'Inam',
          question: 1,
          video: in2,
          subtitle: "",
          key: "in1"
      },
      {
          person: 'Inam',
          question: 2,
          video: in3,
          subtitle: "",
          key: "in2"
      },
      {
          person: 'Inam',
          question: 3,
          video: in4,
          subtitle: "",
          key: "in3"
      },
      {
          person: 'Inam',
          question: 4,
          video: in5,
          subtitle: "",
          key: "in4"
      },
      {
          person: 'Inam',
          question: 5,
          video: in6,
          subtitle: "",
          key: "in5"
      },
      {
          person: 'Inam',
          question: 6,
          video: in7,
          subtitle: "",
          key: "in6"
      },
      {
          person: 'Inam',
          question: 7,
          video: in8,
          subtitle: "",
          key: "in7"
      },
      {
          person: 'Inam',
          question: 8,
          video: in9,
          subtitle: "",
          key: "in8"
        },
 
        {
            person: 'Sevan',
            question: 0,
            video: se1,
            subtitle: "",
            key: "se0"
          },
          {
              person: 'Sevan',
              question: 1,
              video: se2,
              subtitle: "",
              key: "se1"
          },
          {
              person: 'Sevan',
              question: 2,
              video: se3,
              subtitle: "",
              key: "se2"
          },
          {
              person: 'Sevan',
              question: 3,
              video: se4,
              subtitle: "",
              key: "se3"
          },
          {
              person: 'Sevan',
              question: 4,
              video: se5,
              subtitle: "",
              key: "se4"
          },
          {
              person: 'Sevan',
              question: 5,
              video: se6,
              subtitle: "",
              key: "se5"
          },
          {
              person: 'Sevan',
              question: 6,
              video: se7,
              subtitle: "",
              key: "se6"
          },
          {
              person: 'Sevan',
              question: 7,
              video: se8,
              subtitle: "",
              key: "se7"
          },
          {
              person: 'Sevan',
              question: 8,
              video: se9,
              subtitle: "",
              key: "se8"
            },
  ]